import styled from "styled-components";
import Mesa from '../img/Mesa.png'

export const DivFale = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 540;
    overflow: hidden;
    border-radius: 6px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-image:
        repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.35) 0 1px, transparent 1px 48px),
        repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.35) 0 1px, transparent 1px 48px),
        url(${Mesa});
    background-size: 48px 48px, 48px 48px, cover;
    background-position: center;
    background-repeat: repeat, repeat, no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        padding: 2% 5%;
        box-sizing: border-box;
    }

    h1 {
        font-size: 2.0vw;
        font-weight: 800;
        color: #171717;
        margin: 0 0 1.5% 0;
    }

    .coluna-esquerda {
        width: 58%;
    }

    .contato-item {
        display: flex;
        align-items: flex-start;
        gap: 0.8vw;
        margin-top: 0.8%;
        text-decoration: none;
        color: inherit;

        img, .icone-pin {
            width: 1.3vw;
            height: 1.3vw;
            object-fit: contain;
            margin-top: 0.15vw;
            flex-shrink: 0;
            transition: transform 0.15s ease;
        }

        strong {
            display: block;
            font-size: 1.0vw;
            font-weight: 800;
            color: #171717;
            transition: color 0.15s ease;
        }

        p {
            margin: 0.1vw 0 0;
            font-size: 0.85vw;
            line-height: 1.3;
            color: #262626;
            font-weight: 500;
        }
    }

    a.contato-item {
        cursor: pointer;

        :hover {
            img { transform: scale(1.2); }
            strong { color: #E53935; }
        }
    }

    .coluna-direita {
        width: 42%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .logo {
            width: 6vw;
            margin-bottom: 2%;
        }

        .mapa {
            width: 100%;
            flex: 1;
            background: rgba(255, 255, 255, 0.55);
            border-radius: 0.8vw;
            overflow: hidden;

            iframe {
                width: 100%;
                height: 100%;
                border: 0;
                display: block;
            }
        }
    }

    .linha-final {
        position: absolute;
        left: 5%;
        bottom: 5%;
        width: 42%;
        height: 0.3vw;
        background-color: #F5A623;

        .quadrado {
            position: absolute;
            top: 50%;
            right: -1vw;
            transform: translateY(-50%);
            width: 1vw;
            height: 1vw;
            background-color: #F5A623;
        }
    }

    .montanhas {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 15vw;
        height: 5vw;
        pointer-events: none;

        .tri {
            position: absolute;
            bottom: -0.5vw;
            width: 0;
            height: 0;
        }

        .amarelo {
            right: 1.7vw;
            border-left: 2.5vw solid transparent;
            border-right: 2.5vw solid transparent;
            border-bottom: 3.3vw solid #F4E04D;
        }

        .vermelho {
            right: 4vw;
            border-left: 3vw solid transparent;
            border-right: 3vw solid transparent;
            border-bottom: 4.2vw solid #E53935;
        }

        .laranja {
            right: 0;
            border-left: 3.6vw solid transparent;
            border-right: 3.6vw solid transparent;
            border-bottom: 5vw solid #F5A623;
        }
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;
        background-size: 24px 24px, 24px 24px, cover;

        .conteudo {
            position: static;
            flex-direction: column;
            padding: 6vw 5vw 10vw;
        }

        h1 {
            font-size: 6vw;
            text-align: center;
        }

        .coluna-esquerda {
            width: 100%;
        }

        .contato-item {
            margin-top: 5vw;

            img, .icone-pin {
                width: 5vw;
                height: 5vw;
            }

            strong { font-size: 4vw; }
            p { font-size: 3.5vw; }
        }

        .coluna-direita {
            width: 100%;
            margin-top: 6vw;

            .logo {
                width: 30vw;
                margin-bottom: 5vw;
            }

            .mapa {
                width: 100%;
                height: 60vw;
                border-radius: 3vw;
            }
        }

        .linha-final {
            display: none;
        }

        .montanhas {
            width: 45vw;
            height: 16vw;

            .amarelo { right: 5vw; border-left: 7vw solid transparent; border-right: 7vw solid transparent; border-bottom: 9vw solid #F4E04D; }
            .vermelho { right: 11vw; border-left: 8.5vw solid transparent; border-right: 8.5vw solid transparent; border-bottom: 11vw solid #E53935; }
            .laranja { right: 0; border-left: 10vw solid transparent; border-right: 10vw solid transparent; border-bottom: 13vw solid #F5A623; }
        }
    }
`
